function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.17,
    height: 17.57,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 8.785
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.57,
    width: 25.17,
    height: 18.74,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.677142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 26.939999999999998
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.31,
    width: 25.17,
    height: 19.56,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 46.09
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.86,
    width: 25.17,
    height: 20.26,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 65.99
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.13,
    width: 25.17,
    height: 20.5,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4166666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 86.38
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.62,
    width: 25.17,
    height: 20.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.60625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 107.045
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.47,
    width: 25.17,
    height: 21.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5716666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 128.185
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.9,
    width: 25.17,
    height: 24.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.00125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 150.905
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.91,
    width: 25.17,
    height: 24.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.872
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 175.09
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.27,
    width: 25.17,
    height: 26.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9361538461538463
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 200.565
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 213.85,
    width: 25.17,
    height: 28.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 227.905
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.96,
    width: 25.17,
    height: 28.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 256.305
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 270.65,
    width: 25.17,
    height: 28.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.14625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 284.995
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 299.35,
    width: 25.17,
    height: 29.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.14625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 314.105
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 328.86,
    width: 25.17,
    height: 30.1,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 343.91
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.96,
    width: 25.17,
    height: 31.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 374.47999999999996
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 389.99,
    width: 25.17,
    height: 31.5,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 405.74
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 421.5,
    width: 25.17,
    height: 31.97,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.034000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 437.485
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 453.47,
    width: 25.17,
    height: 32.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.14625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 469.81
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 486.15,
    width: 25.17,
    height: 32.91,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 502.60499999999996
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.06,
    width: 25.17,
    height: 34.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5170000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 536.2149999999999
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 553.37,
    width: 25.17,
    height: 35.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.14625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 570.9350000000001
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 588.51,
    width: 25.17,
    height: 36.07,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 606.545
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 624.58,
    width: 25.17,
    height: 37.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 643.375
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 662.17,
    width: 25.17,
    height: 37.83,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.585,
    y: 681.0849999999999
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 0,
    width: 28.04,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.608
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.19,
    y: 17.025
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.21,
    y: 0,
    width: 28.39,
    height: 34.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7316666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.405,
    y: 17.025
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 0,
    width: 28.65,
    height: 34.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.925,
    y: 17.025
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.25,
    y: 0,
    width: 30.55,
    height: 34.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3944444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.525,
    y: 17.025
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 0,
    width: 31.94,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.77,
    y: 17.025
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.73,
    y: 0,
    width: 32.37,
    height: 34.05,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.915,
    y: 17.025
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.1,
    y: 0,
    width: 32.72,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.45999999999998,
    y: 17.025
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.82,
    y: 0,
    width: 33.5,
    height: 34.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.583333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.57,
    y: 17.025
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.32,
    y: 0,
    width: 33.5,
    height: 34.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.583333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.07,
    y: 17.025
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.81,
    y: 0,
    width: 34.01,
    height: 34.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.802
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.815,
    y: 17.025
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.83,
    y: 0,
    width: 34.1,
    height: 34.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.88,
    y: 17.025
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.93,
    y: 0,
    width: 34.88,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.37,
    y: 17.025
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.81,
    y: 0,
    width: 35.05,
    height: 34.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.25625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.335,
    y: 17.025
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.86,
    y: 0,
    width: 35.14,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.43,
    y: 17.025
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 0,
    width: 35.66,
    height: 34.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.83,
    y: 17.025
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.66,
    y: 0,
    width: 36,
    height: 34.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.66,
    y: 17.025
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.66,
    y: 0,
    width: 37.39,
    height: 34.05,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.355,
    y: 17.025
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.05,
    y: 0,
    width: 37.56,
    height: 34.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.25625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.8299999999999,
    y: 17.025
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.61,
    y: 0,
    width: 37.65,
    height: 34.05,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.4350000000001,
    y: 17.025
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 662.26,
    y: 0,
    width: 37.74,
    height: 34.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.25625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.13,
    y: 17.025
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 34.05,
    width: 36.79,
    height: 35.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.098000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 51.795
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 69.55,
    width: 36.79,
    height: 36.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.629
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 87.695
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 105.84,
    width: 36.79,
    height: 37.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.255714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 124.47
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 143.1,
    width: 36.79,
    height: 37.5,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 161.85
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 180.59,
    width: 36.79,
    height: 38.14,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 199.66
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 218.73,
    width: 36.79,
    height: 38.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.255714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 237.88
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 257.02,
    width: 36.79,
    height: 38.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 276.49
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 295.96,
    width: 36.79,
    height: 38.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 315.42999999999995
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 334.9,
    width: 36.79,
    height: 39.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 354.53
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 374.16,
    width: 36.79,
    height: 39.42,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.255714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 393.87
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 413.58,
    width: 36.79,
    height: 39.66,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 433.40999999999997
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 453.23,
    width: 36.79,
    height: 40.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 473.3
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 493.37,
    width: 36.79,
    height: 40.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 513.52
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 533.67,
    width: 36.79,
    height: 40.7,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 554.02
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 574.37,
    width: 36.79,
    height: 41.42,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 595.08
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 615.8,
    width: 36.79,
    height: 42.06,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 636.8299999999999
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 657.86,
    width: 36.79,
    height: 42.14,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.565,
    y: 678.9300000000001
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 34.05,
    width: 38.91,
    height: 40.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.484999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.405,
    y: 54.349999999999994
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.87,
    y: 34.05,
    width: 39.27,
    height: 40.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.854000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.50500000000001,
    y: 54.349999999999994
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.14,
    y: 34.05,
    width: 39.64,
    height: 40.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6066666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.95999999999998,
    y: 54.349999999999994
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.78,
    y: 34.05,
    width: 40.65,
    height: 40.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.105,
    y: 54.349999999999994
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 34.05,
    width: 40.94,
    height: 40.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.9,
    y: 54.349999999999994
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.38,
    y: 34.05,
    width: 41.74,
    height: 40.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.25,
    y: 54.349999999999994
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.12,
    y: 34.05,
    width: 42.18,
    height: 40.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.21,
    y: 54.349999999999994
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.3,
    y: 34.05,
    width: 42.18,
    height: 40.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.39,
    y: 54.349999999999994
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.47,
    y: 34.05,
    width: 42.18,
    height: 40.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.56,
    y: 54.349999999999994
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.65,
    y: 34.05,
    width: 43.05,
    height: 40.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.17499999999995,
    y: 54.349999999999994
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.7,
    y: 34.05,
    width: 43.19,
    height: 40.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.29499999999996,
    y: 54.349999999999994
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.9,
    y: 34.05,
    width: 43.48,
    height: 40.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.64,
    y: 54.349999999999994
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.38,
    y: 34.05,
    width: 46.24,
    height: 40.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.5,
    y: 54.349999999999994
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.63,
    y: 34.05,
    width: 47.19,
    height: 40.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.225,
    y: 54.349999999999994
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.81,
    y: 34.05,
    width: 47.19,
    height: 40.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.405,
    y: 54.349999999999994
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 74.65,
    width: 44.26,
    height: 43.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 96.49000000000001
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 118.34,
    width: 44.26,
    height: 44.22,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.844
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 140.45
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 162.55,
    width: 44.26,
    height: 45.41,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.917777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 185.255
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 207.97,
    width: 44.26,
    height: 45.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.322857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 230.81
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 253.65,
    width: 44.26,
    height: 46.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.322857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 276.825
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 299.99,
    width: 44.26,
    height: 47.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 323.765
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 347.54,
    width: 44.26,
    height: 48.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 371.88
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 396.22,
    width: 44.26,
    height: 49.34,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 420.89000000000004
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 445.56,
    width: 44.26,
    height: 49.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 470.53
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 495.5,
    width: 44.26,
    height: 50.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.376666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 520.87
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 546.24,
    width: 44.26,
    height: 51.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.376666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 571.775
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 597.32,
    width: 44.26,
    height: 51.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.376666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 622.8900000000001
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 648.46,
    width: 44.26,
    height: 51.54,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.322857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.08,
    y: 674.23
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 74.65,
    width: 43.47,
    height: 52.95,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.955,
    y: 101.125
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.69,
    y: 74.65,
    width: 46.09,
    height: 52.95,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.218
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.735,
    y: 101.125
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.77,
    y: 74.65,
    width: 46.64,
    height: 52.95,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.09,
    y: 101.125
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.42,
    y: 74.65,
    width: 46.92,
    height: 52.95,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.88,
    y: 101.125
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.34,
    y: 74.65,
    width: 47.14,
    height: 52.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.90999999999997,
    y: 101.125
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    y: 74.65,
    width: 48.37,
    height: 52.95,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.909999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.665,
    y: 101.125
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.85,
    y: 74.65,
    width: 51.32,
    height: 52.95,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.331428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.51000000000005,
    y: 101.125
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.17,
    y: 74.65,
    width: 51.37,
    height: 52.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.42125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.855,
    y: 101.125
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 74.65,
    width: 51.88,
    height: 52.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.48,
    y: 101.125
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.42,
    y: 74.65,
    width: 52.88,
    height: 52.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.813333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.86,
    y: 101.125
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.3,
    y: 74.65,
    width: 53.71,
    height: 52.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.155,
    y: 101.125
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.01,
    y: 74.65,
    width: 53.99,
    height: 52.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.005,
    y: 101.125
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 127.61,
    width: 54.62,
    height: 53.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.585714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 154.16
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 180.7,
    width: 54.62,
    height: 54.39,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 207.89499999999998
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 235.09,
    width: 54.62,
    height: 55.31,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 262.745
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 290.4,
    width: 54.62,
    height: 55.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8028571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 318.19
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 345.98,
    width: 54.62,
    height: 56.76,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8028571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 374.36
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 402.74,
    width: 54.62,
    height: 56.93,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 431.205
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 459.67,
    width: 54.62,
    height: 58.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 488.675
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 517.67,
    width: 54.62,
    height: 60.27,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 547.805
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 577.95,
    width: 54.62,
    height: 60.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 608.085
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.22,
    y: 638.22,
    width: 54.62,
    height: 61.78,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8028571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.53,
    y: 669.11
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 127.61,
    width: 56.72,
    height: 61.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.302222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.2,
    y: 158.57999999999998
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.56,
    y: 127.61,
    width: 57.62,
    height: 61.94,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.231428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.37,
    y: 158.57999999999998
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.18,
    y: 127.61,
    width: 57.77,
    height: 61.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.252857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.065,
    y: 158.57999999999998
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.95,
    y: 127.61,
    width: 58.76,
    height: 61.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.33,
    y: 158.57999999999998
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.71,
    y: 127.61,
    width: 60.14,
    height: 61.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.59142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.78,
    y: 158.57999999999998
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.86,
    y: 127.61,
    width: 61.24,
    height: 61.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.206666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.48,
    y: 158.57999999999998
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.09,
    y: 127.61,
    width: 61.81,
    height: 61.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.995,
    y: 158.57999999999998
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.9,
    y: 127.61,
    width: 62.52,
    height: 61.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.882222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.16,
    y: 158.57999999999998
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.43,
    y: 127.61,
    width: 62.57,
    height: 61.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.7149999999999,
    y: 158.57999999999998
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 189.55,
    width: 62.82,
    height: 61.98,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 220.54000000000002
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 251.53,
    width: 62.82,
    height: 62.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 282.755
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 313.98,
    width: 62.82,
    height: 62.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.82375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 345.27500000000003
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 376.58,
    width: 62.82,
    height: 62.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 408.015
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 439.45,
    width: 62.82,
    height: 64.19,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.974285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 471.54499999999996
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 503.64,
    width: 62.82,
    height: 64.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.564
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 535.8299999999999
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 568.01,
    width: 62.82,
    height: 65.36,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 600.6899999999999
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.84,
    y: 633.37,
    width: 62.82,
    height: 66.63,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.25,
    y: 666.685
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 189.55,
    width: 65.12,
    height: 65.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.22,
    y: 222.16000000000003
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.77,
    y: 189.55,
    width: 66.07,
    height: 65.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.80499999999995,
    y: 222.16000000000003
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.84,
    y: 189.55,
    width: 66.11,
    height: 65.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.895,
    y: 222.16000000000003
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.95,
    y: 189.55,
    width: 67.92,
    height: 65.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.90999999999997,
    y: 222.16000000000003
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.87,
    y: 189.55,
    width: 69.19,
    height: 65.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.465,
    y: 222.16000000000003
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.06,
    y: 189.55,
    width: 70.81,
    height: 65.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.4649999999999,
    y: 222.16000000000003
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.87,
    y: 189.55,
    width: 71.13,
    height: 65.22,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.435,
    y: 222.16000000000003
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 254.77,
    width: 69.19,
    height: 71.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.838
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 290.635
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 326.51,
    width: 69.19,
    height: 71.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 362.46
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 398.41,
    width: 69.19,
    height: 72.8,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.884285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 434.81
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 471.21,
    width: 69.19,
    height: 74.72,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.838
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 508.57
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 545.93,
    width: 69.19,
    height: 74.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.884285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 583.3499999999999
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 620.77,
    width: 69.19,
    height: 79.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.255,
    y: 660.385
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 254.77,
    width: 79.29,
    height: 69.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.495,
    y: 289.40000000000003
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.13,
    y: 254.77,
    width: 81.16,
    height: 69.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.894285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.71,
    y: 289.40000000000003
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.29,
    y: 254.77,
    width: 81.29,
    height: 69.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.935,
    y: 289.40000000000003
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.58,
    y: 254.77,
    width: 81.8,
    height: 69.26,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.48,
    y: 289.40000000000003
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.37,
    y: 254.77,
    width: 83.63,
    height: 69.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.926
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.185,
    y: 289.40000000000003
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 324.03,
    width: 86.28,
    height: 68.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.045
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 358.12
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 392.21,
    width: 86.28,
    height: 68.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.575555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 426.29999999999995
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 460.4,
    width: 86.28,
    height: 70.41,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 495.60499999999996
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 530.8,
    width: 86.28,
    height: 82.5,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 572.05
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 613.3,
    width: 86.28,
    height: 86.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 656.65
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 324.03,
    width: 74.28,
    height: 103.33,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.27,
    y: 375.695
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.41,
    y: 324.03,
    width: 76.22,
    height: 103.33,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.52000000000004,
    y: 375.695
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.62,
    y: 324.03,
    width: 77.93,
    height: 103.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.988333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.585,
    y: 375.695
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.55,
    y: 324.03,
    width: 92.45,
    height: 103.33,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.408333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.775,
    y: 375.695
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 427.36,
    width: 88.96,
    height: 127.36,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.61,
    y: 491.04
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 554.72,
    width: 88.96,
    height: 145.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.61,
    y: 627.36
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.09,
    y: 427.36,
    width: 231.91,
    height: 112.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.004285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.045,
    y: 483.375
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 159,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.09,
    y: 539.38,
    width: 231.91,
    height: 160.62,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.045,
    y: 619.69
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.b3e7b71ddc024eae55ca3acb438b8946.svg";
export { ForwardRef as ReactComponent };